import { useMemo } from "react";
import styled, { css } from "styled-components";

import srcOnline from "../../assets/svg/online.svg";
import srcOffline from "../../assets/svg/offline.svg";
import refreshIcon from "../../assets/svg/refresh.svg";
import { useToolContext } from "../ToolContext/ToolContext";

const MainHeader = styled.header`
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 0px 20px;

  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 1.125px 3.375px rgba(0, 0, 0, 0.2);
`;

const ToolName = styled.h1`
  font-weight: 300;
  font-size: 24px;
  line-height: 29px;
  padding-top: 10px;
  margin: 0px;
  flex: 1;

  color: var(--primary-fg);
`;

const RefreshIcon = styled.img`
  cursor: pointer;
`;

type AppStatus = "online" | "offline" | "error";

const AppStatusStyles = {
  online: css`
    color: var(--online-fg);
  `,
  offline: css`
    color: var(--offline-fg);
  `,
  error: css`
    color: var(--error-fg);
  `,
};

const AppStatusText = styled.span<{ status: AppStatus }>`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  padding: 0px 10px;

  ${({ status }) => AppStatusStyles[status]}
`;

const Status = (): JSX.Element => {
  const context = useToolContext();

  const [status, text, src]: [AppStatus, string, string] = useMemo(() => {
    if (context.isOffline) {
      return ["offline", "Offline", srcOffline];
    }

    return ["online", "Online", srcOnline];
  }, [context.isOffline]);

  return (
    <>
      <img src={src} alt="Status Icon" />
      <AppStatusText status={status}>{text}</AppStatusText>
    </>
  );
};

const Header = (): JSX.Element => (
  <MainHeader>
    <ToolName>Lutron Connect</ToolName>
    <Status />
    <RefreshIcon
      data-testid="btn-refresh"
      src={refreshIcon}
      onClick={() => window.location.reload()}
    />
  </MainHeader>
);

export default Header;
